
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { ContractsService } from "../../services/contracts.service";
import { MatStepper } from "@angular/material/stepper";
import { Contact, ContractClient, ContractWebLocal, WebCompany, WebContractAgreement, WebContractLetter, WebContractLetterLocal, WebCustomer, WebCustomerAgingVariables } from "../../models";
import { AuthService, CompanyService, ContactService, CustomerService } from "../../services";
import { MakeAPaymentDialogComponent } from "../aps/make-a-payment-dialog/make-a-payment-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AccountCreditPmtDialogComponent } from "./account-credit-pmt-dialog/account-credit-pmt-dialog.component";
import { LocationListService } from "../../services/location-list.service";
import { ErrorDialogComponent } from "../../components/error-dialog/error-dialog.component";
import { AccountCreditSuccessDialogComponent } from "./account-credit-success-dialog/account-credit-success-dialog.component";
import { SpinnerService } from "../../services/spinner.service";
import { Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
    selector: "app-prebuy",
    templateUrl: "./prebuy.component.html",
    styleUrls: ["./prebuy.component.scss"],
})
export class PrebuyComponent implements OnInit, OnDestroy
{

    @ViewChild("stepper") stepper: MatStepper;

    title = "Prebuy Setup";

    defaultEmail: string;
    userEmail: string = "";
    confEmail: string;

    editEmail: boolean;
    checked = false; // stores terms and conditions checkbox state

    addedToCart: WebContractLetterLocal[] = []; // stores in cart contracts

    availableContracts: WebContractLetterLocal[] = [];

    contractLetters: WebContractLetterLocal[]; // existing AND possible contracts
    contractLetterSubscription: Subscription;

    currentContracts: ContractWebLocal[]; // existing contracts
    currentContractsSubscription: Subscription;

    customerAging: WebCustomerAgingVariables;
    customerAgingSubscription: Subscription;

    customer: WebCustomer;
    company: WebCompany;
    customerSubscription: Subscription;
    companySubscription: Subscription;
    customerName: string;

    contractTotal: number = 0;
    totalDue: number = 0;

    contractLettersLoaded: boolean = false;
    contractsLoaded: boolean = false;
    compareContractsDone: boolean = false;

    contactList: Contact[];
    contactSubscription: Subscription;

    prebuySubscription: Subscription;

    locationListSubscription: Subscription;
    public locationDescription = new Map();

    constructor(
        private contractsService: ContractsService,
        private contractLetterService: ContractsService,
        private customerService: CustomerService,
        private companyService: CompanyService,
        private authService: AuthService,
        public dialog: MatDialog,
        private contactService: ContactService,
        public locationService: LocationListService,
        private contractClient: ContractClient,
        private spinnerService: SpinnerService,
        private router: Router
    ) { }

    ngOnInit(): void
    {
        this.prebuySubscription = this.contractsService.prebuySwitch.subscribe(r =>
        {
            if (r === false && !this.authService.getCurrentUserInfo().isCompany)
            {
                this.router.navigate(["/not-found"]);
            }
        });
        this.companySubscription = this.companyService.company.subscribe(response =>
        {
            this.company = response;
        });

        this.contractLettersLoaded = false;
        this.contractsLoaded = false;
        this.compareContractsDone = false;

        this.contractLetterSubscription = this.contractLetterService.contractLetter.subscribe(s =>
        {
            this.contractLetters = s;
            this.contractLettersLoaded = true;
            this.compareContracts();
        });

        this.currentContractsSubscription = this.contractsService.contract.subscribe(c =>
        {
            this.currentContracts = c;
            this.contractsLoaded = true;
            this.compareContracts();
        });

        this.contactSubscription = this.contactService.contacts.subscribe(c =>
        {
            this.contactList = c;
        });

        this.customerAgingSubscription = this.customerService.customerAging.subscribe(customerAging =>
        {
            this.customerAging = customerAging
        });

        this.customerSubscription = this.customerService.customer.subscribe(customer =>
        {
            this.customerName = customer.Name;
        });

        this.locationListSubscription = this.locationService.locationList.subscribe(e =>
        {
        });

        // set editEmail field to show default email or not, set default email if available.
        if (this.contactList.length > 0)
        {
            if (this.contactList[0] == null || this.contactList[0].Email === "")
            {
                this.editEmail = true;
                this.defaultEmail = "none available";
            } 
            else
            {
                this.editEmail = false;
                this.defaultEmail = this.contactList[0].Email;
            }
        } 
        else
        {
            this.editEmail = true;
        }
    }

    /**
     * Check to see which contracts are available for purchase
     */
    compareContracts()
    {

        if (this.contractsLoaded && this.contractLettersLoaded)
        {

            // if no current contracts, all contract letters are available.
            if (this.currentContracts.length === 0)
            {
                for (const contract of this.contractLetters)
                {
                    contract.IsAvailable = true;
                }
            } 
            else
            {
                for (const contract of this.contractLetters)
                {
                    // only run check if field hasn't already been set to false or is null
                    if (contract.IsAvailable === null || true)
                    {
                        for (const item of this.currentContracts)
                        {
                            if (item.Loc === contract.Location)
                            {
                                contract.IsAvailable = false;
                                break;
                            } 
                            else 
                            { contract.IsAvailable = true; }
                        }
                    }
                }
            }
            this.compareContractsDone = true;
        }
    }

    ngOnDestroy()
    {
        this.currentContractsSubscription?.unsubscribe();
        this.contractLetterSubscription?.unsubscribe();
        this.customerAgingSubscription?.unsubscribe();
        this.companySubscription?.unsubscribe();
        this.contactSubscription?.unsubscribe();
        this.customerSubscription?.unsubscribe();
        this.locationListSubscription?.unsubscribe();
        this.prebuySubscription?.unsubscribe();
        this.emptyCart();
    }

    /**
     * Add contract to cart, remove from possible contracts
     */
    addContract(contract: WebContractLetter, indexNum: number)
    {
        this.addedToCart.push(contract);
        this.contractLetters.splice(indexNum, 1);
        this.contractTotal += contract.FullPrebuyCashPrice * contract.FullPrebuyGallons;
    }

    /**
     * Remove contract from cart, add back to possible contracts, subtract price from total
     */
    removeContract(contract: WebContractLetter, indexNum: number)
    {
        this.contractTotal -= contract.FullPrebuyCashPrice * contract.FullPrebuyGallons;
        this.contractLetters.push(contract);
        this.addedToCart.splice(indexNum, 1);
    }

    /**
     * manually control next step. fixed issue with first step not
     * working after manual reset, and allows auto scroll to top for lengthy T&C
     */
    nextClicked()
    {
        this.stepper.selected.completed = true;
        this.stepper.next();
    }

    /**
     * Reset all steps to not completed, reset terms & conditions
     * checkbox state, go back to first step, empty cart.
     */
    resetStepper()
    {
        this.stepper._steps.forEach((step, index) =>
        {
            this.stepper.reset();
            this.stepper.selected.completed = false;
        });
        this.checked = false;
        this.emptyCart();
        this.editEmail = false;
    }

    /**
     * Empty cart, repopulate possible contracts list, reset all fields to empty/zero.
     */
    emptyCart()
    {

        for (const contract of this.addedToCart)
        {
            this.contractLetters.push(contract);
        }
        this.addedToCart = [];
        this.contractTotal = 0;
        this.totalDue = 0;
        this.userEmail = "";
    }

    /**
     * Contract prebuys automatically also include any balance or credit
     * currently on customer's account to get total due.
     */
    calculatePrice()
    {
        this.totalDue = this.contractTotal + this.customerAging.BalDueWithDisc;
    }

    /**
     * Runs the payment dialog, unless acct has sufficient credit to cover contract,
     * then go to final submit pg and write contract.
     */
    public handleMakeAPaymentClicked(): void
    {
        if (this.totalDue > 0)
        {
            const dialogRef = this.dialog.open(MakeAPaymentDialogComponent, {
                panelClass: "form-field-less-than-180",
                minWidth: 100,
                maxWidth: "600px",
                maxHeight: "500px",
                disableClose: true,
            });
            const instance = dialogRef.componentInstance;
            instance.prebuy = true;
            instance.contractTotal = this.contractTotal;
            instance.contractsAdded = this.addedToCart;

            dialogRef.afterClosed().subscribe(_ =>
            {
                this.resetStepper();
                this.contractsService.getContractLetters(); // reload contracts
                this.contractsService.getContractList();
                this.compareContracts();

            });

        } 
        else
        {
            this.nextClicked(); // move to submit pg, skip pmt dialog.
        }
    }

    // this method is only used if user submits payment using account credit, as it will not run through APS stuff.
    public submit(contracts: WebContractLetter[])
    {

        // if user changed email address, use that, else use default.
        const confEmail = this.userEmail !== "" ? this.userEmail : this.defaultEmail;

        // processing dialog
        const dialogRef = this.dialog.open(AccountCreditPmtDialogComponent, {
            panelClass: "form-field-less-than-180",
            width: "600px",
            minHeight: "400px",
            maxHeight: "90%",
            maxWidth: "90%",
            disableClose: true,
        });

        const agreement: WebContractAgreement = {
            Contracts: contracts,
            CustomerEmail: confEmail,
            CustomerName: this.customerName,
            Company: this.company
        }
        this.contractClient.writeContractLetter(agreement).subscribe(c =>
        {
            if (c.Successful)
            {
                dialogRef.close();

                // success dialog
                const dialogRefSuccess = this.dialog.open(AccountCreditSuccessDialogComponent, {
                    panelClass: "form-field-less-than-180",
                    width: "400px",
                    maxWidth: "90%",
                    disableClose: true,
                });

                dialogRefSuccess.afterClosed().subscribe(_ =>
                {
                    this.customerService.populateData(); // reload balances
                    this.contractsService.getContractLetters(); // reload contracts
                    this.contractsService.getContractList();
                });
            }
        },
            (error) =>
            {

                const errorMsg: string = "There was an error processing your contract prebuy. " + error;

                const dialogRefError = this.dialog.open(ErrorDialogComponent, {
                    data: errorMsg,
                    disableClose: true,
                });

                dialogRefError.afterClosed().subscribe(_ =>
                {
                    this.dialog.closeAll();
                    this.contractsService.getContractLetters(); // reload contracts
                    this.contractsService.getContractList();
                });
            });
        this.spinnerService.hide(); // hides background spinner- already have one in dialog.

        this.resetStepper();
        this.compareContracts();
    }
}
